import { type FC, type ComponentProps, lazy, Suspense } from "react";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import * as styles from "./styles.css";
import { SelectedList } from "./uiParts/selectedList";
import { type selectedItemProps, type ActionProps } from "./modules";

const SelectModal = lazy(() =>
  retryLazyLoad({
    fn: () => import("./uiParts/selectModal"),
  }),
);

export type ItemProps = {
  initialChecked: boolean;
  value: string;
  text: string;
  hasRecommendedLabel?: boolean;
  isInexperience?: boolean;
};

export type ItemListProps = Record<
  string,
  {
    items: (ItemProps & ComponentProps<"input">)[];
  }
>;

type Props = {
  formState: selectedItemProps;
  dispatchFormState: React.Dispatch<ActionProps>;
  categoryName: string;
  formName: string;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  isShow: boolean;
  itemList: ItemListProps;
  handleOnClick: () => void;
  setIsAccordionOpen: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
  isAccordionOpen: Record<number, boolean>;
  experienceJobTypeIds: string[];
  inexperienceJobTypeIds: string[];
  experienceInputRef: React.RefObject<HTMLInputElement>;
  inexperienceInputRef: React.RefObject<HTMLInputElement>;
  isBiyo?: boolean;
};

export const Presentation: FC<Props> = ({
  categoryName,
  formName,
  formState,
  dispatchFormState,
  setIsShow,
  isShow,
  itemList,
  handleOnClick,
  setIsAccordionOpen,
  isAccordionOpen,
  experienceJobTypeIds, // 経験職種IDの配列
  inexperienceJobTypeIds, // 未経験職種IDの配列
  experienceInputRef,
  inexperienceInputRef,
  isBiyo,
}) => {
  return (
    <>
      <SelectedList formState={formState} dispatchFormState={dispatchFormState} />
      <button type="button" className={styles.openModalButton} onClick={() => setIsShow(true)}>
        <i className={`icon-plus-1 ${styles.openModalButtonIcon}`} />
        {categoryName}を追加する
      </button>
      <Suspense fallback={null}>
        <SelectModal
          categoryName={categoryName}
          isShow={isShow}
          onClickClose={() => setIsShow(false)}
          itemList={itemList}
          handleOnClick={handleOnClick}
          setIsAccordionOpen={setIsAccordionOpen}
          isAccordionOpen={isAccordionOpen}
          isBiyo={isBiyo}
        />
      </Suspense>
      <input
        ref={experienceInputRef}
        type="hidden"
        name={`form_client_frontend_scout_user_search[${formName}]`}
        id={`form_client_frontend_scout_user_search_${formName}`}
        value={experienceJobTypeIds.length > 0 ? JSON.stringify(experienceJobTypeIds) : ""}
        className="js-search-scoutable-field-disabled-if-value-empty"
      />
      <input
        ref={inexperienceInputRef}
        type="hidden"
        name="form_client_frontend_scout_user_search[inexperience_job_type_id]"
        id="form_client_frontend_scout_user_search_inexperience_job_type_id"
        value={inexperienceJobTypeIds.length > 0 ? JSON.stringify(inexperienceJobTypeIds) : ""}
        className="js-search-scoutable-field-disabled-if-value-empty"
      />
    </>
  );
};
